export class Case {
    constructor() {
        let category_id = 686;
        switch (globalThis.lang) {
            case 'it': category_id = 681; break;
            case 'en': category_id = 686; break;
            case 'de': category_id = 688; break;
            case 'fr': category_id = 684; break;
            case 'es': category_id = 690; break;
        }
        let news_url = `https://www.vipaspa.it/wp-json/wp/v2/posts/?page=1&per_page=10&order=desc&orderby=date&categories[]=${category_id}&_embed`;

        let nc = $("#news-container");
        if (nc !== undefined && nc.length === 1) {
            $.getJSON(news_url, (data) => {
                this.loadSuccess(data)
            }).fail(this.loadFail);
        }
    }

    loadSuccess(data: JQuery.PlainObject): void {
        let nc = $("#news-container");
        if (data instanceof Array && data.length > 0) {
            let maxLength = 200;
            data.forEach(function (news) {
                let content = $(news.excerpt.rendered).text();
                if (content.length > maxLength) {
                    content = content.slice(0, maxLength) + "...";
                }
                nc.append(`
                    <div class="news-cell cell small-4 medium-4 large-4 bg-white pa2 ph3 translate-y--2 br2 shadow-4 hover-b--main-green db">
                        <a class="gray-2 hover-main-green" href="${news.link}" target="_blank">
                        <img class="news-image br-pill h4 w4" loading="lazy" src="${news._embedded['wp:featuredmedia'][0]?.source_url}" alt="${news._embedded['wp:featuredmedia'][0]?.alt_text}" />
                        <div class="cell auto pl2">
                            <p class="news-title mt0 mb2 b">${news.title.rendered}</p>
                            <p class="news-content mt1 mb0">${content}</p>
                        </div>
                        </a>
                    </div>`);
            });
            $("#news-overlay").addClass("hide");
        } else {
            nc.addClass("hide");
        }
    }

    loadFail(): void {
        let nc = $("#news-section");
        nc.addClass("hide");
    }
}
